import type { CourseDetailAiFeedback } from './courseDetailAiFeedback';
import type { CourseDetailSectionsItem } from './courseDetailSectionsItem';
import type { CourseDetailSummary } from './courseDetailSummary';

export interface CourseDetail {
  /**
   * 사용자별 수강 등록에 대한 코스 종합 AI 피드백 (수강생이고 피드백 존재 시 반환)
   * @nullable
   */
  aiFeedback?: CourseDetailAiFeedback;
  /** 강의 상세 설명 */
  description: string;
  sections: CourseDetailSectionsItem[];
  /** 강의 요약 정보 */
  summary: CourseDetailSummary;
}
